// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__1HRyH","text":"SelectPayment_text__3840R","title":"SelectPayment_title__2Uzgj","btn":"SelectPayment_btn__uBW1d"};